/*  ==========================================================================
    GALLERY

    INFO:
    - needs "masonry-layout" for tile output
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'lodash/lodash.js';
import Masonry from 'masonry-layout';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initGallery($element) {

    // magnific popup
    utils.mfp.initGallery($element);

    // initialize masonry on load
    let masonry,
        masonryGrid = $element.find('.bn-gallery__frame')[0],
        masonryOptions = {
            columnWidth: '.bn-gallery__image',
            itemSelector: '.bn-gallery__image',
            percentPosition: true
        };
    masonry = new Masonry(masonryGrid, {masonryOptions});

    // reinitialize masonry on resize
    vars.$page.on('mresize', _.debounce(function () {
        masonry.layout();
    }, 500));

    // show more button if needed
    if ($element.find('.bn-gallery__image').hasClass('hidden')) {
        $element.find('.bn-gallery__foot').removeClass('hidden');
    }

    // show remaining hidden images on click and reinitialize masonry
    $element.on('click', '.bn-gallery__more', function () {
        $(this).addClass('hidden');
        $element.find('.bn-gallery__image.hidden').removeClass('hidden');
        masonry.layout();
    });

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/gallery.js